<template>
  <div class="Goods">
    <Header></Header>

    <div style="width: 1000px;overflow: hidden;overflow-y: auto;scrollbar-width: none; " :style="{
      'margin-left': innerWidth > 1000 ? (innerWidth - 1000) / 2 + 'px' : '0px',
      'height': (innerHeight - 70 - 68) + 'px'
    }">

      <div class="chooseType" style="min-height:60px;height:auto;height: 100px;">
        <div class="chooseTypeText">选择科目：</div>
        <div class="courseNavBox fl" v-for="(item, index) in categoryTypeList" :key="index">
          <div class="list" :class="curTypeId == item.examCategoryId ? 'active' : ''" @click="switchType(item)">
            {{ item.examCategoryName }}
          </div>
        </div>
      </div>

      <div class="courseList" style="clear: both;">
        <div class="course fl" v-for="(good, index) in goodsList" :key="index" @click="goGoodDetail(good.goodsId)">
          <div>
            <div class="courseTitle oneRow ">
              {{ good.goodsName }}
            </div>
            <div class="courseLabelList">
              <div class="singleLabel " v-for="(tag, tagIndex) in good.tags" :key="tagIndex">
                {{ tag.name }}
              </div>
            </div>
          </div>
          <div>
            <div class="courseTeacherList">
              <img :src="teacher.avatarUrl" v-for="(teacher, teacherIndex) in good.teachers" :key="teacherIndex"
                class="courseTeacherImg">
              <div class="moreTeacher" v-if="good.teachers.length < 5">
                <i class="el-icon-more"></i>
              </div>
            </div>
            <div class="buyBox">
              <div class="personIcon"><i class="el-icon-user-solid" style="color:  #737780;font-size: 12px;"></i></div>
              <div class="buyNum">{{ good.studyNum }}人已购</div>
            </div>
            <div class="courseInfo">
              <span style="color: #f2460c;">
                <span class="unit">￥</span>
                <span class="price">{{ (good.costPrice / 100) }}</span>
                <span>起</span>
              </span>
              <div class="shopCart">
                <el-button type="danger" size="mini" round>选购</el-button>
              </div>
            </div>
          </div>

        </div>

      </div>

      <div style="width: 100%; text-align: center;padding-top: 40px;padding-bottom: 30px; clear: both;">
        <el-pagination :page-sizes="[9, 45, 90]" :page-size="query.size" @pagination="selectList"
          @size-change="handleSizeChange" :current-page="query.page" @current-change="handleCurrentChange"
          :total="query.total" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>

    </div>

    <Suspension></Suspension>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/common/Header"
import Footer from "../components/common/Footer"
import Suspension from "../components/common/Suspension"

import {
  getByUrl,
  getByParam
} from '@/api/api.js';

export default {
  name: "Goods",
  data() {
    return {
      query: {
        page: 1,  // 第几页
        size: 9,  // 每页多少条
        total: 0,
      },
      curTypeId: '',
      categoryTypeList: [],
      goodsList: [],
      innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
    }
  },
  mounted() {
    this.getCategoryList()

  },
  methods: {
    goGoodDetail(id) {
      this.$router.push({
        path: '/good/det',
        query: {
          id: id
        }
      })
    },
    switchType(item) {
      this.curTypeId = item.examCategoryId
      this.query.page = 1;
      this.getCategoryGoods()
    },
    handleSizeChange(e) {
      console.log('e', e)
      this.query.size = e;
      this.query.page = 1;
      this.getCategoryGoods();
    },

    getCategoryList() {
      this.categoryTypeList.push({
        examCategoryId: '',
        examCategoryName: '全部'
      })
      getByUrl('/web/examCategory/list').then(res => {
        console.log(res)
        for (let i = 0; i < res.data.length; i++) {
          this.categoryTypeList.push({
            examCategoryId: res.data[i].examCategoryId,
            examCategoryName: res.data[i].name
          })
        }
        this.getCategoryGoods('')
      })

    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.query.page = val;
      this.getCategoryGoods();
    },
    getCategoryGoods() {
      let param = {
        examCategoryId: this.curTypeId,
        pageNum: this.query.page,
        pageSize: this.query.size
      }
      getByParam('/web/examCategoryGood/page', param).then(res => {
        console.log(res)
        this.goodsList = res.data.pageInfo.list
        this.query.total = res.data.pageInfo.total

      })
    },
  },
  components: {
    Header,
    Footer,
    Suspension
  }
}
</script>

<style scoped>
.chooseType {
  margin-top: 24px;
  padding: 16px 24px 0;
  border-radius: 8px;
  background: #fff;
}

.chooseTypeText {
  width: 70px;
  font-size: 14px;
  line-height: 36px;
  margin-right: 8px;
  color: #2b2e33;
  float: left;

}

.list {
  border-radius: 16px;
  background: #f7f8fa;
  color: #737780;
  font-weight: 300;
  font-size: 14px;
  padding: 9px 16px;
  cursor: pointer;
  line-height: 14px;
  margin-left: 15px;
  margin-bottom: 20px;
  /* -webkit-transition: all .3s;
  transition: all .3s; */
}

.active {
  line-height: 14px;
  height: 32px;
  border-radius: 20px;
  box-sizing: border-box;
  color: #399df6;
  font-weight: 600;
  border: .5px solid rgba(5, 193, 183, .10196078431372549);
  background: rgba(5, 193, 183, .10196078431372549);
  box-shadow: 0 4px 8px rgba(0, 204, 156, .0784313725490196);
}

.courseList {
  width: 1000px;
  margin: 0 auto;
  padding-top: 24px;
  /* display: grid; */
  /* margin-right: 20px; */

}

.course {
  cursor: pointer;
  box-sizing: border-box;
  width: 313px;
  border-radius: 16px;
  margin-top: 20px;
  padding: 24px 16px 16px;
  height: 330px;
  margin-right: 20px;
  border: .5px solid #E8EAED;
  background: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-transition: all .3s;
  transition: all .3s;
}

.courseTitle .oneRow {
  -webkit-line-clamp: 1;
}

.courseTitle {
  color: #2B2E33;
  line-height: 26px;
  font-size: 18px;
  font-weight: 600;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /* -webkit-line-clamp: 2; */
  overflow: hidden;
  word-wrap: break-word;
}

.courseLabelList {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  max-height: 112px;
  overflow: hidden;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin-top: 8px;
}

.singleLabel {
  font-size: 12px;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  /* height: 20px; */
  margin: 0 8px 8px 0;
  border: .5px solid rgba(242, 132, 48, .30196078431372547);
  padding: 4px 6px;
  border-radius: 4px;
  background: rgba(242, 132, 48, .03137254901960784);
  color: #f28430;
  line-height: 12px;
  font-weight: 500;
}

.singleCourse {
  cursor: pointer;
  box-sizing: border-box;
  width: 317px;
  border-radius: 16px;
  padding: 24px 16px 16px;
  height: 350px;
  border: .5px solid #e8eaed;
  background: #fff;
  /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-transition: all .3s;
  transition: all .3s;
}

.courseTeacherList {
  display: flex;
}

.courseTeacherImg {
  display: inline-block;
  width: 44px;
  height: 44px;
  margin: 0 12px 0 0;
  border-radius: 50%;
}

.buyBox {
  height: 20px;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 12px;
}

.buyNum {
  font-weight: 300;
  font-size: 12px;
  color: #737780;
}

.courseInfo {
  height: 32px;
  line-height: normal;
  box-sizing: content-box;
  margin-top: 12px;
  padding-top: 12px;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-top: .5px solid #E8EAED;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
}

.unit {
  font-weight: 600;
}

.price {
  font-size: 20px;
  font-weight: 600;
}

.moreTeacher {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: #f7f8fa;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 9px;
  /* margin-left: 60%; */
}
</style>